import { useDispatch, useSelector } from "react-redux";
import { addUser, updateUser, removeUser } from "../redux/slices/usersSlice";

export const useUsers = () => {
  const dispatch = useDispatch();
  const { users } = useSelector((state) => state.users);

  const inviteUser = ({ name, email, role }) => {
    dispatch(addUser({ name, email, role }));
  };

  const editUser = (id, updates) => {
    dispatch(updateUser({ id, updates }));
  };

  const deleteUser = (id) => {
    dispatch(removeUser(id));
  };

  return { users, inviteUser, editUser, deleteUser };
};
